import { render, staticRenderFns } from "./invoiceFix.vue?vue&type=template&id=c4892e12&scoped=true&"
import script from "./invoiceFix.vue?vue&type=script&lang=js&"
export * from "./invoiceFix.vue?vue&type=script&lang=js&"
import style0 from "./invoiceFix.vue?vue&type=style&index=0&id=c4892e12&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4892e12",
  null
  
)

export default component.exports